<template>
  <div v-if="!isMissingWebsite" class="description metric-colon">
    <span class="label" :id="websiteLabelId" v-html="descDisplayText"></span>
    <LinkExternalUrl v-if="hasWebsiteSlot" :url="websiteValue" :labelId="websiteLabelId"/>
    <template v-else>{{defaultValue}}</template>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component'

import LinkExternalUrl from '@/components/LinkExternalUrl'
import { MetadataDescMixin, MetadataWebsiteMixin } from './metadata-mixin'

@Component({
  components: {
    LinkExternalUrl
  }
})
export default class MetricDescColon extends mixins(MetadataDescMixin, MetadataWebsiteMixin) {
  /* Getters */

  get isMissingWebsite () { return this.hasWebsiteSlot && !this.hasWebsiteValue }
  get websiteLabelId () {
    return this.hasWebsiteSlot ? 'metric-desc-colon-' + this._uid : undefined
  }

  // Override default template text if there is website text
  get customTemplateText () { return this.websiteDispText }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/sqs/2018/tab-mods/MetricDescColon.vue